/**
 * Display Field Component (Feature 022)
 *
 * Reusable component for displaying read-only profile information
 * in a consistent format with label, value, optional icon and hint.
 */

import { ReactNode } from 'react';

type DisplayFieldValue = string | number | boolean | null | undefined;

type DisplayFieldProps = {
  label: string;
  value: DisplayFieldValue;
  icon?: ReactNode;
  hint?: string;
  className?: string;
};

export function DisplayField({ label, value, icon, hint, className = '' }: DisplayFieldProps) {
  // Format the display value
  const displayValue = () => {
    if (value === null || value === undefined) {
      return <span className="text-text-tertiary italic">Not set</span>;
    }
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No';
    }
    return String(value);
  };

  return (
    <div className={`space-y-1 ${className}`}>
      {/* span, not label: there is no form control to associate with */}
      <span className="block text-sm font-medium text-text-secondary">{label}</span>
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-base text-text-primary">{displayValue()}</span>
      </div>
      {hint && <p className="text-xs text-text-tertiary">{hint}</p>}
    </div>
  );
}
